import UserApi from '@/data/users/UserApi.ts';
import { chain } from 'lodash';

export default {
  methods: {
    async getUsersOfCompany(
      companyId: number,
      companyName: string,
    ): Promise<any> {
      let response = await new UserApi()
        .forwardToErrorPageOnException()
        .getAllUsersOfCompany(companyId);

      return {
        companyId: companyId,
        companyName: companyName,
        data: response.data.filter((user) => !user.robot),
      };
    },
    getUniqueUsers(users: Array<object>) {
      const seenEmails = new Set();
      return users.map((company) => {
        // @ts-ignore data not defined
        let uniqueUsers = company.data.filter((item) => {
          const duplicate = seenEmails.has(item.email);
          seenEmails.add(item.email);
          return !duplicate;
        });

        const uniqueUsersSorted = chain(uniqueUsers)
          .sortBy([(user) => user.first_name.toLowerCase()], ['desc'])
          .sortBy((user) => (user.email === 'support@sundata.nl' ? 0 : 1))
          .value();

        return { ...company, data: uniqueUsersSorted };
      });
    },
  },
};
